.wrapper {
  border-radius: var(--rds-roundness--button);
}

.menu-text-item {
  --bg-color: var(--rds-button-tertiary-bg);
  min-height: 72px;

  display: grid;
  place-items: center;
  text-align: center;
  padding: var(--rds-spacing--12) var(--rds-spacing--24);

  border-radius: var(--rds-roundness--button);
  background-color: var(--bg-color);
  transition: ease 0.125s;
  transition-property: background-color, box-shadow;
  transform: scale(0.95);
  outline: none;
  text-decoration: none;
}

.menu-text-item:hover {
  --bg-color: var(--rds-button-tertiary-hover-bg);
  box-shadow: var(--rds-shadow--hover);
  transform: scale(1);
  box-shadow: var(--rds-shadow--hover);
}

.menu-item-title {
  margin: 0;
}

.selected {
  background-color: var(--rds-foreground-tertiary);
  text-decoration: underline var(--rds-foreground-overlay-heavy) solid var(--rds-spacing--2);
  text-underline-offset: var(--rds-spacing--4);
}
